import { MobileCommPositionTable } from "../MobileCommPositionTable";
import { Button, DataSource, HorizontalSpacer, Label, Layout, LayoutHeader, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommPositionList extends Layout {
    buttonClear: Button;
    buttonExpand: Button;
    buttonSearch: Button;
    horizontalspacer1: HorizontalSpacer;
    labelFilters: Label;
    layoutAll: MobileCommPositionTable;
    layoutDrivers: MobileCommPositionTable;
    layoutTractors: MobileCommPositionTable;
    layoutTrailers: MobileCommPositionTable;
    layoutheaderMCPosition: LayoutHeader;
    panelFilter: Panel;
    panelFilterComponents: Panel;
    panelFilterContent: Panel;
    panelFilterHeader: Panel;
    sourceMobileCommPosition: DataSource;
    switchCurrentPositions: Switch;
    tabAll: Tab;
    tabDrivers: Tab;
    tabTractors: Tab;
    tabTrailers: Tab;
    tabsetMobileCommPositionList: Tabset;
    textboxDateRange: Textbox;
    textboxDriver: Textbox;
    textboxGroups: Textbox;
    textboxUnit: Textbox;
}
